import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";

export default function RescheduleSidebar({
  isOpen,
  onClose,
  selectedToken,
  appontmentdate,
  // setSelectedDate,
  selectedSlot,
  setSelectedSlot,
  selectedappointmentid,
  doctorid,
}) {
  const API_URL = process.env.REACT_APP_API_URL;
  const [doctorlist, setDoctorlist] = useState([]);
  const [specialization, setSpecialization] = useState("");
  const [doctorFullName, setDoctorFullName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [availableSlots, setAvailableSlots] = useState([]);
  const [appointmentdata, setAppointmentdata] = useState();
  const [slotTimes, setSlotTimes] = useState([]);
  console.log(doctorid, "doctorid");
  useEffect(() => {
    // fetchdoctor();
    fetchappointmentdetails();
  }, []);

  const fetchappointmentdetails = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const formattedDate = format(appontmentdate, "yyyy-MM-dd");
    try {
      const response = await axios.get(
        `${API_URL}queue/appointmentlist?whenAppointment=${formattedDate}&appointmentId=${selectedappointmentid}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      console.log(response.data[0], "drtfgyuhijklvgbhjnk");
      setAppointmentdata(response.data[0]);
      // setReporntname(response.data.signedUrl);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      fetchAvailableSlots(selectedDate);
    }
  }, [selectedDate]);
  // const fetchdoctor = async () => {
  //   const token = localStorage.getItem("auth_token");

  //   try {
  //     const response = await axios.get(
  //       `${API_URL}doctor/list?clinicId=CLINIC001`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log(response.data, "esdrtfyguijokp");
  //     setDoctorlist(response.data);
  //   } catch (error) {
  //     console.error("Error fetching slots:", error);
  //   }
  // };
  const fetchAvailableSlots = async (date) => {
    const formattedDate = date.toISOString().split("T")[0];
    // const doctorCode = doctorName;
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");

    try {
      const response = await axios.get(`${API_URL}slot/available`, {
        params: {
          doctorCode: doctorid,
          date: formattedDate,
          slotDuration: 5,
          clinicId: clinicId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      setAvailableSlots(response.data || []);
      setSlotTimes(response.data.map((item) => item.slot));
    } catch (error) {
      console.error("Error fetching slots:", error);
      setAvailableSlots([]);
      setSlotTimes([]);
    }
  };

  const handlereschedule = async () => {
    if (!doctorid) {
      toast.error("Please select a doctor.");
      return;
    }

    if (!selectedSlot) {
      toast.error("Please select a time slot.");
      return;
    }

    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");

    // These params will be passed to the API
    const appointmentId = appointmentdata.appointmentId;
    const doctorId = doctorName; // or appointmentdata.userId if that's the doctor's code
    const date = selectedDate.toISOString().split("T")[0];
    const fromTime = selectedSlot.split("-")[0];
    const toTime = selectedSlot.split("-")[1];

    // Compose skipAppointment URL
    const url =
      `${API_URL}queue/skipAppointment` +
      `?appointmentId=${encodeURIComponent(appointmentId)}` +
      `&doctorId=${encodeURIComponent(doctorid)}` +
      `&date=${encodeURIComponent(date)}` +
      `&startTime=${encodeURIComponent(fromTime)}` +
      `&endTime=${encodeURIComponent(toTime)}`;
    console.log(url, "url");

    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      if (res.ok) {
        toast.success("Appointment rescheduled successfully!");
        onClose();
      } else {
        const data = await res.json();
        const msg = data?.message || "Failed to skip (reschedule) appointment.";
        toast.error(msg);
      }
    } catch (err) {
      console.error("Skip error:", err);
      toast.error("Something went wrong.");
    }
  };

  console.log(appointmentdata, "appointmentdata");
  return (
    <div className="fixed top-0 right-0 z-50 h-full w-full max-w-md bg-white shadow-lg border-l border-gray-200 p-6 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-[#004276]">
          Reschedule Appointment
        </h2>
        <button onClick={onClose}>
          <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* Form */}
      <div className="space-y-5">
        {/* <div>
          <label className="text-sm font-medium text-gray-600">
            Re-send Token No.
          </label>
          <input
            type="text"
            placeholder="Please enter patient symptoms over here"
            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
            value={selectedToken}
            readOnly
          />
        </div> */}

        {/* <div className="flex gap-4">
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">
              Specialization
            </label>
            <input
              type="text"
              value={specialization}
              readOnly
              onChange={(e) => setSpecialization(e.target.value)}
              className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-100"
            />
          </div>

          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">
              Doctor Name
            </label>
            <select
              value={doctorName}
              onChange={(e) => {
                const selectedCode = e.target.value;
                setDoctorName(selectedCode);

                // Find the doctor from the list
                const selectedDoctor = doctorlist.find(
                  (doc) => doc.doctorCode === selectedCode
                );

                // Set specialization and full name
                setSpecialization(selectedDoctor?.specialization || "");
                setDoctorFullName(selectedDoctor?.fullName || "");
              }}
              className="w-full h-[50px] px-4 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring focus:ring-blue-100"
            >
              <option value="">Select</option>
              {doctorlist?.map((doctor) => (
                <option key={doctor.doctorCode} value={doctor.doctorCode}>
                  {doctor.fullName}
                </option>
              ))}
            </select>
          </div>
        </div> */}

        <div>
          <label className="text-sm font-medium text-gray-600">
            Change Date & Time:
          </label>
          <div className="mt-1">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              dateFormat="dd/MM/yyyy"
              minDate={new Date()}
              inline
            />
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block mb-5">
            Available Slots
          </label>
          {availableSlots.length === 0 ? (
            <p className="text-sm text-gray-500">
              No slots available for the selected date.
            </p>
          ) : (
            <div className="h-80 overflow-y-auto border border-gray-200 rounded-md p-4 bg-gray-50">
            <div className=" grid grid-cols-3 gap-3">
              {availableSlots.map((s, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedSlot(s.slot)}
                  disabled={s.available === "N"} // disable if not available
                  className={`px-4 py-2 rounded-md m-1 text-sm border transition-all duration-200 
      ${
        s.available === "Y"
          ? selectedSlot === s.slot
            ? "bg-[#004172] text-white transform scale-95 border-[#004276]"
            : "text-[#004172] border-[#004276] hover:bg-[#e9f2f7] active:scale-95"
          : "border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed"
      }`}
                >
                  {s.slot.split("-")[0]}
                </button>
              ))}
              {/* {availableSlots
                .filter((s) => s.available === "Y")
                .map((s) => (
                  <button
                    key={s.slot}
                    onClick={() => setSelectedSlot(s.slot)}
                    className={`w-full border border-[#004172] px-4 py-2 text-sm rounded transition font-medium ${
                      selectedSlot === s.slot
                        ? "bg-[#004172] text-white"
                        : "text-[#004172] hover:bg-[#e9f2f7]"
                    }`}
                  >
                    {s.slot.split("-")[0]}
                  </button>
                ))} */}
            </div>
            </div>
          )}
        </div>

        <div className="flex justify-between items-center mt-6">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-[#004276] text-[#004276] rounded-full text-sm"
          >
            Close
          </button>
          <button
            className="px-6 py-2 bg-[#004276] text-white rounded-full text-sm"
            onClick={handlereschedule}
          >
            Reschedule
          </button>
        </div>
      </div>
    </div>
  );
}
